export default __webpack_public_path__ + "static/media/carousel1.2e634fa0.png";